export const dataTypes = {
    NOTEBOOK_NAME:'DIFF_ENGINE_NOTEBOOK',
    DIFF_ENGINE_HISTORY:'DIFF_ENGINE_HISTORY'
}